import { templateJoin } from 'bernie-graphql';

    export const activityDestinationViewSearchQuery = templateJoin`
        query ActivityDestinationViewSearch(
    $context: ContextInput!
    $destination: ActivityDestinationInput!
    $dateRange: ActivityDateRangeInput
    $sort: ActivitySort
    $filters: ActivitySearchFiltersInput
    $pagination: PaginationInput
    $marketing: ActivityMarketingInfoInput
    $searchViewOptions: [ActivitySearchViewOptions!]
) {
    activitySearch(
        context: $context
        destination: $destination
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        pagination: $pagination
        marketing: $marketing
        searchViewOptions: $searchViewOptions
    ) {
        searchSummary {
            pageInfo {
                pageId
                pageName
                title
            }
            pageHeading
            paginationInfo {
                pageSize
            }
            messages {
                index
                type
                title {
                    text
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                }
                subtitle {
                    text
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                }
                action {
                    primary {
                        href
                        rfrr
                        text
                    }
                    secondary {
                        href
                        rfrr
                        text
                    }
                }
            }
            activitySize
            marketSize
            dateValidationResult {
                dateAdjusted
                searchedStartDate {
                    day
                    month
                    year
                    shortDateFormat
                    fullDateFormat
                }
                searchedEndDate {
                    day
                    month
                    year
                    shortDateFormat
                    fullDateFormat
                }
            }
            aboveTheFold {
                pills {
                    label
                    selections {
                        id
                        value
                    }
                    analytics {
                        linkName
                        referrerId
                        microMessagePayload
                    }
                }
                banners {
                    title
                    subtitle
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                    action {
                        href
                        text
                        rfrr
                    }
                    type
                }
                breadcrumbs {
                    label
                    selectionsToRemove {
                        id
                        value
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                }
            }
            resolvedRegion {
                regionId
                regionName
                fullRegionName
            }
        }
        activityGroups {
            name
            type
            viewType
            id
            action {
                label
                url
                analytics {
                    linkName
                    referrerId
                }
            }
            activityTiles {
                __typename
                ... on ActivitySearchByKeywordTile {
                    dismiss {
                        description
                        id
                    }
                    icon {
                        description
                        id
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                    searchTerm
                    placeholder
                }
                ... on Activity {
                    id
                    name
                    description
                    supplierName
                    analytics {
                        referrerId
                        linkName
                    }
                    image {
                        description
                        url
                    }
                    badges {
                        secondary {
                            text
                            type
                            icon {
                                description
                                id
                                size
                                withBackground
                            }
                            mark {
                                description
                                id
                            }
                        }
                        primary {
                            text
                            type
                            icon {
                                description
                                id
                                size
                                withBackground
                            }
                            mark {
                                description
                                id
                            }
                        }
                    }
                    duration {
                        formatted
                        icon {
                            id
                        }
                    }
                    features {
                        volumePricing {
                            description
                        }
                        freeCancellation {
                            formatted
                            type
                        }
                        loyaltyEarnAwards {
                            mark {
                              id
                            }
                            label
                        }
                        pinnedTopBottom {
                            tileTop {
                                description
                            }
                            tileBottom {
                                id
                                description
                            }
                        }
                        likelyToSellOut {
                            formatted
                        }
                        travelDuration {
                            formatted
                        }
                        travelDistance {
                            label
                        }
                        hotelPickup {
                            icon_temp {
                                id
                            }
                            label
                        }
                        enhancedCleaning {
                            label
                            icon_temp {
                                id
                                size
                            }
                        }
                    }
                    leadTicket {
                        label
                        type
                        price {
                            lead {
                                formatted
                            }
                            strikeOut {
                                formatted
                            }
                        }
                        loyaltyPointsOption {
                            formattedPoints
                        }
                        priceAccessibilityText
                        taxesAndFeesMessage
                    }
                    reviewSummary {
                        reviewRatingMessage
                        reviewCountMessage
                        source
                        isExternalSource
                        score {
                            formatted
                            raw
                        }
                        total
                        verifiedReviewsMessage {
                            clickAction {
                                ...on ActivityPopupClickAction {
                                    text
                                    dismissAction {
                                        href
                                        rfrr
                                        text
                                    }
                                }
                                analytics {
                                    linkName
                                    referrerId
                                }
                            }
                            icon {
                                description
                                id
                            }
                            text
                        }
                        sectionRef
                    }
                    thirdPartyPartnerName
                    clickAction {
                        openInNewTab
                    }
                }
                ... on ActivityBasicTile {
                    name
                    link
                    image {
                        description
                        url
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                    secondaryMessage
                }
                ... on ActivityMessageTile {
                    type
                    title {
                        text
                    }
                    subtitle {
                        text
                    }
                    action {
                        first {
                            text
                            clickAction {
                                __typename
                                analytics {
                                    microMessagePayload
                                    linkName
                                    referrerId
                                }
                                ... on ActivityLinkClickAction {
                                    linkTagUrl
                                    anchorTagUrl
                                    opensInNewTab
                                    accessibilityText
                                }
                                ... on ActivityPopupClickAction {
                                    dismissAction {
                                        text
                                        href
                                        rfrr
                                    }
                                    title
                                    text
                                }
                            }
                        }
                        second {
                            text
                            clickAction {
                                __typename
                                analytics {
                                    microMessagePayload
                                    linkName
                                    referrerId
                                }
                                ... on ActivityLinkClickAction {
                                    linkTagUrl
                                    anchorTagUrl
                                    opensInNewTab
                                    accessibilityText
                                }
                                ... on ActivityPopupClickAction {
                                    dismissAction {
                                        text
                                        href
                                        rfrr
                                    }
                                    title
                                    text
                                }
                            }
                        }
                    }
                    icon {
                        description
                        id
                        withBackground
                        size
                    }
                    mark {
                        description
                        id
                    }
                    analytics {
                        linkName
                        referrerId
                    }
                }
                ... on ActivityTextTile {
                    anchoredText {
                        clickAction {
                            analytics {
                                linkName
                                referrerId
                            }
                            ... on ActivityLinkClickAction {
                                anchorTagUrl
                                opensInNewTab
                                accessibilityText
                            }
                        }
                        icon {
                            id
                            description
                        }
                        text
                    }
                    text
                    size
                }
            }
        }
        sortAndFilter {
            sortAndFilterSections {
                dismiss {
                    description
                    id
                }
                fields {
                    id
                    label
                    udsToken
                    ... on ActivitySelectionField {
                        options {
                            primary
                            secondary
                            icon {
                                description
                            }
                            analytics {
                                linkName
                                referrerId
                            }
                            nestedOptions {
                                icon {
                                    description
                                }
                                primary
                                secondary
                                selected
                                enabled
                                value
                                analytics {
                                    linkName
                                    referrerId
                                }
                            }
                            selected
                            enabled
                            value
                        }
                    }
                    ... on ActivityTextInputSortField {
                        id
                        label
                        udsToken
                        placeholder
                        value
                    }
                }
                title
            }
        }
    }
}

    `;

    export const activityDetailOffersQuery = templateJoin`
        query ActivityDetailOffers(
    $context: ContextInput!
    $activityId: String!
    $destination: ActivityDestinationInput
    $dateRange: ActivityDateRangeInput
    $marketing: ActivityMarketingInfoInput
    $filter: ActivityOfferFilterInput!
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        destination: $destination
        dateRange: $dateRange
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
    ) {
        offers(filter: $filter) {
            activityOfferTicketsSummary {
                title
                icon
                activityOfferTicketsSummaryMessages {
                    href
                    icon
                    text
                    rfrr
                    type
                    extendedMessage {
                        text
                        action {
                            href
                            text
                            rfrr
                        }
                    }
                }
            }
            availableTime {
                day
                hour
                minute
                month
                second
                year
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
                fullDateFormat
                raw
                shortDateFormat
                shortTimeFormat
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut{
                    formatted
                }
                nonRefundable {
                    title
                    subTitle
                }
            }
            badges {
                secondary {
                    text
                    type
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                    mark {
                        description
                        id
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ...on ActivityPopupClickAction {
                            text
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                defaultSelectedCount
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                loyaltyEarnAwards {
                    loyaltyEarnAmount {
                        amount
                        currencyInfo {
                            code
                            name
                            symbol
                        }
                        formatted(formatWholeValue: false)
                    }
                }
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
        recommendation {
            title
        }

        offersSummary {
            filters {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
    }
}

    `;

    export const activityDetailBasicQuery = templateJoin`
        query ActivityDetailBasic(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $marketing: ActivityMarketingInfoInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
    ) {
        telesales {
            label
            phoneNumberLink {
                phoneNumber
                value
            }
            analytics {
                linkName
                referrerId
            }
        }
        tabbedNavigationBar {
            tabs {
                label
                sectionRef
                analytics {
                    linkName
                    referrerId
                }
            }
        }
        availabilities {
            date {
                isoFormat
                day
                month
                year
                fullDateFormat
            }
            isAvailable
            price {
                formatted
            }
        }
        availabilityCalendar {
            date {
                isoFormat
            }
            price {
                formatted
            }
        }
        location {
            event {
                coordinates {
                    latitude
                    longitude
                }
                address {
                    firstLine
                    secondLine
                    thirdLine
                    city
                    province
                    zipCode
                    country
                }
                description
                region {
                    regionId
                    regionName
                    fullRegionName
                }
            }
            redemption {
                address {
                    firstLine
                    secondLine
                    thirdLine
                    province
                    city
                    zipCode
                    country
                }
                description
                coordinates {
                    latitude
                    longitude
                }
                distanceFromHotel {
                    text
                    size
                }
            }
            sectionRef
        }
        gallery {
            featuredMedia {
                __typename
                ... on Image {
                    description
                    url
                }
                ... on Video {
                    description
                    videoUrl: url {
                        ... on HttpURI {
                            value
                            relativePath
                        }
                    }
                }
            }
            medias {
                __typename
                ... on Image {
                    description
                    url
                }
                ... on Video {
                    description
                    videoUrl: url {
                        ... on HttpURI {
                            value
                            relativePath
                        }
                    }
                }
            }
        }
        uisPayload {
            detailsPayload
        }
        presentation {
            partnerProvidedDetails {
                heading
                body
            }
            title
            staticMap
            pointsToRemember {
                __typename
                headingGraphic {
                    ... on Icon {
                        description
                        id
                    }
                }
                key
                heading
                items
                structuredItems {
                    icon {
                        description
                        id
                    }
                    label
                }
                sectionRef
                sectionRefLink {
                    analytics {
                        microMessagePayload
                        linkName
                        referrerId
                    }
                    ... on ActivityRefClickAction {
                        label
                        sectionRef
                    }
                }
            }
            banners {
                title
                subtitle
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                }
                type
                action {
                    rfrr
                    href
                    text
                }
            }
            features {
                label
                subtext
                url
                icon {
                    description
                    id
                }
                mark {
                    description
                    id
                }
            }
            loyaltyPointsValue {
                formatted
                currencyInfo {
                    code
                    name
                    symbol
                }
                amount
            }
            promotionMessage {
                type
                mark {
                    description
                    id
                }
                icon {
                    description
                    id
                    size
                    withBackground
                }
                subtitle
                title
                action {
                    primary {
                        __typename
                        text
                        url
                    }
                    secondary {
                        __typename
                        text
                        url
                    }
                }
                clickAction {
                    first {
                        text
                        clickAction {
                            __typename
                            analytics {
                                microMessagePayload
                                linkName
                                referrerId
                            }
                            ... on ActivityLinkClickAction {
                                linkTagUrl
                                anchorTagUrl
                                opensInNewTab
                            }
                            ... on ActivityPopupClickAction {
                                dismissAction {
                                    text
                                    href
                                    rfrr
                                }
                                title
                                text
                            }
                        }
                    }
                    second {
                        text
                        clickAction {
                            __typename
                            analytics {
                                microMessagePayload
                                linkName
                                referrerId
                            }
                            ... on ActivityLinkClickAction {
                                linkTagUrl
                                anchorTagUrl
                                opensInNewTab
                            }
                            ... on ActivityPopupClickAction {
                                dismissAction {
                                    text
                                    href
                                    rfrr
                                }
                                title
                                text
                            }
                        }
                    }
                }
                analytics {
                    linkName
                    referrerId
                }
            }
        }
        activity {
            supplierName
            reviewSummary {
                reviewCountMessage
                source
                isExternalSource
                score {
                    formatted
                    raw
                }
                total
                verifiedReviewsMessage {
                    clickAction {
                        ... on ActivityPopupClickAction {
                            text
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
                sectionRef
            }
            description
            name
            image {
                description
                url
            }
            id
            redemption {
                type
            }
            sectionRef
        }
        offersSummary {
            leadTicketView {
                action {
                    text
                }
                message
                ticket {
                    label
                    price {
                        lead {
                            formatted
                            amount
                        }
                        strikeOut {
                            formatted
                            amount
                        }
                    }
                    loyaltyPointsOption {
                        formattedPoints
                    }
                    priceAccessibilityText
                    likelyToSellOut {
                        formatted
                    }
                }
            }
            filters {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
    }
}

    `;

    export const activityDetailOfferQuery = templateJoin`
        query ActivityDetailOffer(
    $context: ContextInput!
    $activityId: String!
    $destination: ActivityDestinationInput
    $dateRange: ActivityDateRangeInput
    $marketing: ActivityMarketingInfoInput
    $offerId: String!
    $filter: ActivityOfferFilterInput!
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        destination: $destination
        dateRange: $dateRange
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
    ) {
        offer(offerId: $offerId, filter: $filter) {

            activityOfferTicketsSummary{
                title
                icon
                activityOfferTicketsSummaryMessages {
                    href
                    icon
                    text
                    rfrr
                    type
                    extendedMessage {
                        text
                        action {
                            href
                            text
                            rfrr
                        }
                    }
                }
            }
            availableTime {
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut{
                    formatted
                }
                nonRefundable {
                    title
                    subTitle
                }
            }
            badges {
                secondary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                }
                mark {
                    description
                    id
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ...on ActivityPopupClickAction {
                            text
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                defaultSelectedCount
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                loyaltyEarnAwards {
                    loyaltyEarnAmount {
                        amount
                        currencyInfo {
                            code
                            name
                            symbol
                        }
                        formatted(formatWholeValue: false)
                    }
                }
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
    }
}

    `;

    export const activityDetailOffersWithAvailabilityQuery = templateJoin`
        query ActivityDetailOffersWithAvailability(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $marketing: ActivityMarketingInfoInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        marketing: $marketing
        detailsViewOptions: $detailsViewOptions
    ) {
        availabilities {
            date {
                isoFormat
                day
                month
                year
                fullDateFormat
            }
            isAvailable
            price {
                formatted
            }
        }
        availabilityCalendar {
            date {
                isoFormat
            }
            price {
                formatted
            }
        }
        presentation {
            banners {
                title
                subtitle
                icon {
                    description
                    id
                    size
                    withBackground
                }
                mark {
                    description
                    id
                }
                type
                action {
                    rfrr
                    href
                    text
                }
            }
            promotionMessage {
                type
                mark {
                    description
                    id
                }
                icon {
                    description
                    id
                    size
                    withBackground
                }
                subtitle
                title
                action {
                    primary {
                        text
                        url
                    }
                    secondary {
                        text
                        url
                    }
                }
                analytics {
                    linkName
                    referrerId
                }
            }
        }
        uisPayload {
            detailsPayload
        }
        offersSummary {
            leadTicketView {
                action {
                    text
                }
                message
                ticket {
                    label
                    price {
                        lead {
                            formatted
                            amount
                        }
                    }
                    likelyToSellOut{
                        formatted
                    }
                }
            }
            filters {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
        offers {
            activityOfferTicketsSummary{
                title
                icon
                activityOfferTicketsSummaryMessages {
                    href
                    icon
                    text
                    rfrr
                    type
                    extendedMessage {
                        text
                        action {
                            href
                            text
                            rfrr
                        }
                    }
                }
            }
            availableTime {
                day
                hour
                minute
                month
                second
                year
                epochSeconds
                formatted(format: "yyyy-MM-dd HH:mm:ss")
                fullDateFormat
                raw
                shortDateFormat
                shortTimeFormat
            }
            priceMetaData {
                discountType
                discountPercent
            }
            activityOfferMessages {
                vbpMessage
                likelyToSellOut{
                    formatted
                }
            }
            badges {
                secondary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
                primary {
                    text
                    type
                    mark {
                        description
                        id
                    }
                    icon {
                        description
                        id
                        size
                        withBackground
                    }
                }
            }
            description
            features {
                icon {
                    description
                    id
                }
                mark {
                    description
                    id
                }
                label
                subtext
                url
                anchoredSubtext {
                    clickAction {
                        ...on ActivityPopupClickAction {
                            text
                            dismissAction {
                                href
                                rfrr
                                text
                            }
                        }
                        analytics {
                            linkName
                            referrerId
                        }
                    }
                    icon {
                        description
                        id
                    }
                    text
                }
            }
            id
            promoId
            name
            maxTicketSelectionAllowed
            hotelPickupAvailable
            priceType
            count
            ticketTypes {
                maxSelectableCount
                minSelectableCount
                step
                defaultSelectedCount
                label
                promoId
                restrictionText
                ticketKey
                ticketSingular
                ticketPlural
                loyaltyEarnAwards {
                    loyaltyEarnAmount {
                        amount
                        currencyInfo {
                            code
                            name
                            symbol
                        }
                        formatted(formatWholeValue: false)
                    }
                }
                prices {
                    selectedCount
                    perTravelerPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalPrice {
                        lead {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                        strikeOut {
                            amount
                            currencyInfo {
                                code
                                name
                                symbol
                            }
                            formatted(formatWholeValue: false)
                        }
                    }
                    totalLoyaltyPointsOption {
                        pointsAmount {
                            raw
                        }
                        pointsUnit
                        leadingCaption
                    }
                }
            }
            selections {
                id
                title
                fields {
                    label
                    theme
                    value
                }
            }
        }
        recommendation {
            title
        }
    }
}

    `;

    export const activityDetailRecommendationsQuery = templateJoin`
        query ActivityDetailRecommendations(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        detailsViewOptions: $detailsViewOptions
    ) {
        uisPayload {
            recommendationPayload
        }
        recommendation {
            title
            activities {
                id
                name
                description
                supplierName
                thirdPartyPartnerName
                analytics {
                    referrerId
                    linkName
                    microMessagePayload
                }
                features {
                    volumePricing {
                        description
                    }
                    freeCancellation {
                        formatted
                        type
                    }
                    likelyToSellOut{
                        formatted
                    }
                    travelDistance {
                        label
                    }
                    hotelPickup {
                        icon_temp {
                            id
                        }
                        label
                    }
                }
                duration {
                    formatted
                    icon {
                        id
                    }
                }
                image {
                    url
                    description
                }
                location {
                    latitude
                    longitude
                }
                leadTicket {
                    label
                    type
                    price {
                        lead {
                            formatted
                        }
                        strikeOut {
                            formatted
                        }
                    }
                }
                reviewSummary {
                    total
                    score {
                        formatted
                    }
                }
                badges {
                    secondary {
                        text
                        type
                        mark {
                            description
                            id
                        }
                        icon {
                            description
                            id
                            size
                            withBackground
                        }
                    }
                    primary {
                        text
                        type
                        mark {
                            description
                            id
                        }
                        icon {
                            description
                            id
                            size
                            withBackground
                        }
                    }
                }
            }
        }
    }
}

    `;

    export const activityDetailReviewsQuery = templateJoin`
        query ActivityDetailReviews(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $sortBy: ActivityReviewSort
    $pagination: PaginationInput
    $source: String
    $detailsViewOptions: [ActivityDetailViewOptions!]
) {
    activityInfo(
        context: $context
        activityId: $activityId
        dateRange: $dateRange
        destination: $destination
        detailsViewOptions: $detailsViewOptions
    ) {
        reviews(sortBy: $sortBy, pagination: $pagination, source: $source) {
            text
            author
            id
            activityDate {
                formatted(format: "MMM dd, yyyy")
                longDateFormat
            }
            submissionDate {
                raw
                formatted(format: "MMM dd, yyyy")
                longDateFormat
            }
            overallRating {
                formatted
                raw
            }
            reviewedOn
            userLocation
            helpfulVotes {
                count
                message
            }
        }
    }
}

    `;

    export const activityPageSeoContentQuery = templateJoin`
        query ActivityPageSeoContent(
    $context: ContextInput!
    $activityId: String
    $pageType: ActivityPageType!
) {
    activitySeoContent(
        context: $context
        activityId: $activityId
        pageType: $pageType
    ) {
        canonicalUrl {
            value
        }
        metaTags {
            content
            metaTagType
            metaTagValue
        }
        hreflangLinks {
            href
            hrefLang
        }
        title
    }
}

    `;

    export const upvoteReviewQuery = templateJoin`
        mutation UpvoteReview($id: String!) {
    upvoteActivityReview(id: $id)
}

    `;

    export const fetchShortlistedQuery = templateJoin`
        query FetchShortlisted($context: ContextInput!) {
    shortlist(context: $context) {
        details {
            productId
        }
    }
}

    `;

    export const removeShortlistItemQuery = templateJoin`
        mutation RemoveShortlistItem($context: ContextInput!, $productId: String!) {
    removeShortlistItem(context: $context, productId: $productId, productType: LX_DETAILS) {
        result
    }
}

    `;

    export const saveShortlistItemQuery = templateJoin`
        mutation SaveShortlistItem($context: ContextInput!, $productId: String!) {
    saveShortlistItem(context: $context, productId: $productId, productType: LX_DETAILS) {
        id
    }
}

    `;

